import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=677ecf1d&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677ecf1d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677ecf1d')) {
      api.createRecord('677ecf1d', component.options)
    } else {
      api.reload('677ecf1d', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=677ecf1d&scoped=true", function () {
      api.rerender('677ecf1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/article/edit.vue"
export default component.exports